import api from '@/api'

const SET_FARMS = 'SET_FARMS'
const SET_RATIONS = 'SET_RATIONS'
const SET_GROUPS = 'SET_GROUPS'
const SET_ANIMALTYPES = 'SET_ANIMALTYPES'
const SET_INGREDIENTS = 'SET_INGREDIENTS'
const SET_INGREDIENTTYPES = 'SET_INGREDIENTTYPES'
const SET_MIXERS = 'SET_MIXERS'
const SET_STOCKS = 'SET_STOCKS'
const SET_COUNT = 'SET_COUNT'
const SET_DATE_FILTERS = 'SET_DATE_FILTERS'

export default {
  namespaced: true,

  state () {
    return {
      farms: [],
      rations: [],
      groups: [],
      animaltypes: [],
      ingredients: [],
      ingredienttypes: [],
      mixers: [],
      stocks: [],
      dateFilters: {},
      count: 0
    }
  },

  getters: {
    farms: (state) => state.farms,
    rations: (state) => state.rations,
    groups: (state) => state.groups,
    animaltypes: (state) => state.animaltypes,
    ingredients: (state) => state.ingredients,
    ingredienttypes: (state) => state.ingredienttypes,
    mixers: (state) => state.mixers,
    stocks: (state) => state.stocks,
    dateFilters: (state) => state.dateFilters,
    count: (state) => state.count
  },

  mutations: {
    [SET_DATE_FILTERS] (state, filters) {
      state.dateFilters = filters
    },

    [SET_FARMS] (state, data) {
      state.farms = data
    },

    [SET_RATIONS] (state, data) {
      state.rations = data
    },

    [SET_GROUPS] (state, data) {
      state.groups = data
    },

    [SET_ANIMALTYPES] (state, data) {
      state.animaltypes = data
    },

    [SET_INGREDIENTS] (state, data) {
      state.ingredients = data
    },

    [SET_INGREDIENTTYPES] (state, data) {
      state.ingredienttypes = data
    },

    [SET_MIXERS] (state, data) {
      state.mixers = data
    },

    [SET_STOCKS] (state, data) {
      state.stocks = data
    },

    [SET_COUNT] (state, count) {
      state.count = count
    }
  },

  actions: {
    applyDateFilters ({ commit, state }, filters = {}) {
      const dateFilters = {}
      if (filters.history_date_after) dateFilters.history_date_after = filters.history_date_after
      if (filters.history_date_before) dateFilters.history_date_before = filters.history_date_before
      if (state.dateFilters.history_date_after !== dateFilters.history_date_after ||
        state.dateFilters.history_date_before !== dateFilters.history_date_before) {
        commit(SET_DATE_FILTERS, dateFilters)
      }
    },

    async loadFarms ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.farms.list(filters)
      commit(SET_COUNT, count)
      commit(SET_FARMS, data)
    },

    async loadRations ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.rations.list(filters)
      commit(SET_COUNT, count)
      commit(SET_RATIONS, data)
    },

    async loadGroups ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.groups.list(filters)
      commit(SET_COUNT, count)
      commit(SET_GROUPS, data)
    },

    async loadAnimaltypes ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.animaltypes.list(filters)
      commit(SET_COUNT, count)
      commit(SET_ANIMALTYPES, data)
    },

    async loadIngredients ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.ingredients.list(filters)
      commit(SET_COUNT, count)
      commit(SET_INGREDIENTS, data)
    },

    async loadIngredienttypes ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.ingredienttypes.list(filters)
      commit(SET_COUNT, count)
      commit(SET_INGREDIENTTYPES, data)
    },

    async loadMixers ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.mixers.list(filters)
      commit(SET_COUNT, count)
      commit(SET_MIXERS, data)
    },

    async loadStocks ({ commit, state }, params = {}) {
      const filters = { ...state.dateFilters }
      for (const key in params) {
        filters[key] = params[key]
      }
      const { data, count } = await api.history.stocks.list(filters)
      commit(SET_COUNT, count)
      commit(SET_STOCKS, data)
    }
  }
}
